<div>

  <mat-form-field>
    <mat-label>Handläggare</mat-label>

    <mat-select [(ngModel)]="advisor">
      <mat-option value=""></mat-option>
      @for (advisor of advisors(); track $index) {
        <mat-option [value]="advisor">{{ advisor }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Kontor</mat-label>

    <mat-select [(ngModel)]="office">
      <mat-option value=""></mat-option>
      @for (office of offices(); track $index) {
        <mat-option [value]="office">{{ office }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Filtrera</mat-label>
    <input matInput [(ngModel)]="text">
  </mat-form-field>
</div>
